module.exports = __webpack_public_path__ + "img/prize-03.10cf9f60.png";